import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Avatar.theme = Avatar.theme || {};

Avatar.theme.Collapse = function CollapseFn() {
  var classes = {
    show: 'show',
    collapse: 'collapse',
    collapsed: 'collapsed',
    collapsing: 'collapsing'
  };

  function Collapse(toggle, target) {
    this.toggle = toggle;
    this.target = target;

    this._cacheSelectors();

    this._setupListeners();
  }

  Collapse.prototype = _objectSpread(_objectSpread({}, Collapse.prototype), {}, {
    _cacheSelectors: function _cacheSelectors() {
      this.cache = {
        toggle: this.toggle,
        target: document.querySelector("".concat(this.target))
      };
    },
    _setupListeners: function _setupListeners() {
      this.eventHandlers = this._setupEventHandlers();
      this.cache.toggle.addEventListener('click', this.eventHandlers.handleToggleClick);
    },
    _setupEventHandlers: function _setupEventHandlers() {
      return {
        handleToggleClick: this._handleToggleClick.bind(this)
      };
    },
    _handleToggleClick: function _handleToggleClick(evt) {
      evt.preventDefault();

      if (this.cache.target.classList.contains(classes.show)) {
        this._hide();
      } else {
        this._show();
      }
    },
    _show: function _show() {
      var _this = this;

      this.cache.target.classList.remove(classes.collapse);
      this.cache.target.classList.add(classes.collapsing);
      this.cache.target.style.height = 0;
      this.cache.target.style.height = "".concat(this.cache.target.scrollHeight, "px");

      this.cache.target.ontransitionend = function () {
        _this.cache.target.style.height = '';

        _this.cache.target.classList.remove(classes.collapsing);

        _this.cache.target.classList.add(classes.collapse, classes.show);
      };

      this.cache.toggle.setAttribute('aria-expanded', true);
    },
    _hide: function _hide() {
      var _this2 = this;

      this.cache.target.style.height = "".concat(this.cache.target.getBoundingClientRect().height, "px");
      this.cache.target.classList.add(classes.collapsing);
      this.cache.target.classList.remove(classes.collapse, classes.show);

      this._reflow(this.cache.target);

      this.cache.target.ontransitionend = function () {
        _this2.cache.target.classList.remove(classes.collapsing);

        _this2.cache.target.classList.add(classes.collapse);
      };

      this.cache.target.style.height = '';
      this.cache.toggle.setAttribute('aria-expanded', false);
    },
    _reflow: function _reflow(element) {
      return element.offsetHeight;
    },
    destroy: function destroy() {
      this.cache.toggle.removeEventListener('click', this.eventHandlers.handleToggleClick);
    }
  });
  return Collapse;
}();